import React, { Fragment, useState } from 'react';
import ReactDom, { unmountComponentAtNode, createPortal } from "react-dom";
import VGPopUp from '../components/Controls/VGPopUp'
import { utils } from '../utils/Utils';
import { AsyncAjaxGet } from '../components/Utilities/AsyncAjaxService';
import Toast, { WarningToast } from '../components/Utilities/Toast';
import $ from 'jquery'
import Loader from '../components/Common/Loader';
import RenderBusinessLocation from '../components/BusinessControls/RenderBusinessLocation';

const MultiLocationDropdown = (props: any) => {
    const [validation, setvalidation] = useState(false);
    const Sitedata = props.Sitedata;
    const BusinessData = utils.MultiLocationData(props.userContext, props.userContext.bidHash);
    const [isLoading, setLoading] = useState(false);
    const useModal = false;
    const isGC = (props.Mode == "gcAddCart" ? true : false); // if its from the gift card popup we need to hide then show the gc popup when dismissed so flag here.
    let keepContentHidden = props.keepContentHidden;

    const GetBusinessTabInfo = async (encBID: string, businessData: any, VagaroURL: string) => {
        const url = "merchants/" + encBID;
        await AsyncAjaxGet(
            url,
            props.userContext.accessToken,
            function onSuccess(data: any) {
                try {
                    if (data != null && data.data != null && data.data.data != null) {
                        var businessinfo = data.data.data
                        $(".wbloader").css("display", "none");
                        switch (props.Mode) {
                            case "wbBook":
                                if (businessinfo.isShowBookNowTab) {
                                    props.OnClickEvent(VagaroURL);
                                } else {
                                    Toast(businessinfo.businessName + " can not provide Book-Now.");
                                }
                                break;
                            case "wbClasses":
                                if (businessinfo.isShowClassTab) {
                                    props.OnClickEvent(VagaroURL);
                                    break;
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Class.");
                                }
                                break;
                            case "packageAddCart":
                                if (businessinfo.isPackageShow) {
                                    const multiGroupPackage = props.Package.multiGroupPackage;
                                    if (!utils.isNullEmptyOrWhiteSpace(multiGroupPackage)) {
                                        var pdata = JSON.parse(multiGroupPackage);
                                        if (pdata.length > 0) {
                                            var location = pdata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                var packageData: any = {};
                                                packageData.PID = location[0].PID;
                                                props.OnClickEvent(encBID, false, true, packageData);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + " can not provide Package.");
                                        }
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Package.");
                                }
                                break;

                            case "membershipAddCart":
                                if (businessinfo.isShowMembership) {
                                    const MultiGroupMembership = props.Membership.multiGroupMembership;
                                    if (!utils.isNullEmptyOrWhiteSpace(MultiGroupMembership)) {
                                        var mdata = JSON.parse(MultiGroupMembership);
                                        if (mdata.length > 0) {
                                            var location = mdata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                var membershipData: any = {};
                                                membershipData.MID = location[0].MID;
                                                props.OnClickEvent(props.action, encBID, false, true, membershipData);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + " can not provide Membership.");
                                        }
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Membership.");
                                }
                                break;

                            case "gcAddCart":
                                if (businessinfo.isShowGCTab) {
                                    const MultiGroupGC = props.GiftCard.multiGroupGC;
                                    if (!utils.isNullEmptyOrWhiteSpace(MultiGroupGC)) {
                                        var mdata = JSON.parse(MultiGroupGC);
                                        if (mdata.length > 0) {
                                            var location = mdata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                props.OnClickEvent(encBID, mdata.BID);
                                                props.setammoutvalue(0);
                                            }

                                        }
                                        else {
                                            Toast(businessinfo.businessName + "can not provide Gift Certificate");
                                        }
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + "can not provide Gift Certificate");
                                }
                                break;

                            case "serviceAddCart":
                                if (businessinfo.isShowServiceTab) {
                                    const multiGroupService = props.service.multiGroupService;
                                    if (!utils.isNullEmptyOrWhiteSpace(multiGroupService)) {
                                        var sdata = JSON.parse(multiGroupService);
                                        if (sdata.length > 0) {
                                            var location = sdata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                var serviceData: any = {};
                                                serviceData.SID = location[0].SID;
                                                serviceData.ISADDON = location[0].ISADDON;
                                                props.OnClickEvent(encBID, false, true, serviceData);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + " can not provide Services.");
                                        }
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Services.");
                                }
                                break;
                            case "addOnServiceAddCart":
                                if (businessinfo.isShowServiceTab) {
                                    const multiGroupService = props.service.multiGroupService;
                                    if (!utils.isNullEmptyOrWhiteSpace(multiGroupService)) {
                                        var servicedata = JSON.parse(multiGroupService);
                                        if (servicedata.length > 0) {
                                            var location = servicedata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                props.OnClickEvent(props.service, props.commonData, props.userContext, props.event, props.allowMultiLoc, false, encBID, location[0].SID, location[0].ISADDON);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + " can not provide Services.");
                                        }
                                    }
                                    else {
                                        props.OnClickEvent(props.service, props.commonData, props.userContext, props.event, props.allowMultiLoc, false, encBID);
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Services.");
                                }
                                break;
                            case "productAddCart":
                                if (businessinfo.isShowProductTab) {
                                    const multiGroupInventory = props.Item.multiGroupInventory;
                                    if (!utils.isNullEmptyOrWhiteSpace(multiGroupInventory)) {
                                        var servicedata = JSON.parse(multiGroupInventory);
                                        if (servicedata.length > 0) {
                                            var businessfilter = props.userContext.MultilocationData.filter(
                                                (col: any) => col.encBID === encBID
                                            );
                                            var location = servicedata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                props.OnClickEvent(props.Item, props.userContext, props.allowMultiLoc, false, encBID, location[0].IID);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + "can not provide Product");
                                        }
                                    }
                                    else {
                                        props.OnClickEvent(props.Sitedata, props.userContext, props.userContext, props.event, props.allowMultiLoc, false, encBID);
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + " can not provide Product.");
                                }
                                break;
                            case "Cart":
                                props.OnClickEvent(props.data, props.userContext, false, VagaroURL);
                                break;
                            case "ServiceBook":
                                if (businessinfo.isShowServiceTab) {
                                    const multiGroupService = props.service.multiGroupService;
                                    if (!utils.isNullEmptyOrWhiteSpace(multiGroupService)) {
                                        var servicedata = JSON.parse(multiGroupService);
                                        if (servicedata.length > 0) {
                                            var location = servicedata.filter(
                                                (col: any) => col.BID === businessData
                                            );
                                            if (location.length > 0) {
                                                props.OnClickEvent(props.service, props.commonData, props.userContext, props.event, props.allowMultiLoc, false, VagaroURL, location[0].SID, location[0].ISADDON);
                                            }
                                        }
                                        else {
                                            Toast(businessinfo.businessName + " can not provide Book.");
                                        }
                                    }
                                    else {
                                        props.OnClickEvent(props.service, props.commonData, props.userContext, props.event, props.allowMultiLoc, false, VagaroURL);
                                    }
                                }
                                else {
                                    Toast(businessinfo.businessName + "can not provide Book");
                                }
                                break;

                            default:
                                break;
                        }
                    }
                    else {

                    }

                } catch (error) {
                    setLoading(false);
                }
            },
            function OnError() {
                setLoading(false);
            }
        );
    }

    const getContentHeight = () => {
        let fullHeight = window.innerHeight;
        let header = document.getElementById("wbheader");
        let footer = document.getElementById("wbfooter");
        if(header)
                fullHeight -= header.offsetHeight;
        if(footer) 
                fullHeight -= footer.offsetHeight;
        return fullHeight;

    }

    const PopupBody = () => {

        let height =  getContentHeight()+"px";
        return (
            <Fragment>
                {validation && WarningToast("Please select atleast one location.", setvalidation)}
                {utils.IsFromProApp() && <div id="warning-toast-root"></div>}
                <div className={`form-row search-control-location`} style={{ position: 'relative', minHeight: height, width: "100%" }}>
                    <div className='flex-row w-full justify-content-center align-items-center'>
                        {!useModal && <div className="section-buffer" style={{ width: "calc(50% - var(--half-width))" }}></div>}
                        <div className='mulit-location-padding w-full'>
                            <RenderBusinessLocation siteData={props.userContext} layout={"1"} layoutID={"1"} pages={props.userContext.pages} isShowLogo={"true"}
                                validLocations={Sitedata}
                                overrideOnChange={(encBID, bidHash, vagaroURL) => EventChangeEmbeded(encBID, bidHash, vagaroURL)} data={null}
                                IsCheckSelectFilter={props.Mode == "Cart" ? false : true}
                                IsLocationControl= {false}
                                />
                        </div>
                        {!useModal && <div className="section-buffer" style={{ width: "calc(50% - var(--half-width))" }}></div>}
                    </div>
                </div>

            </Fragment>
        );
    }


    const handlepopupClose = () => {
        if (props.Mode == "wbClasses" || props.Mode == "wbBook") {
            props.OnClickEvent(BusinessData.vagaroURL);
            unmountComponentAtNode(document.getElementById("OpenDialogMultiLocation") as HTMLElement);
        }
        else {
            unmountComponentAtNode(document.getElementById("OpenDialogMultiLocation") as HTMLElement);
        }
    }


    const EventChangeEmbeded = (EncBID: string, EncBIDHash: string, VagaroURL: string) => {
        console.log("event changed...");
        if (EncBID === undefined || EncBID === null || EncBID === "") {
            setvalidation(true);
        }
        else {
            setvalidation(false)
            GetBusinessTabInfo(EncBID, EncBIDHash, VagaroURL);
            $(".wbloader").css("display", "block");
            let portal = document.getElementById("multilocation-portal");

            if(keepContentHidden){ // if we aren't showing content instead show the empty iframe container and set full height

                let dom = document.getElementById("divVagaroIframe");
                if(dom){
                    dom.style.display = "block";
                    dom.style.height = getContentHeight()+"px";
                }
            }

            else if (portal ) {

                if( isGC){
                    let gcDom = document.getElementById("vgGiftCertificte");
               
                    if(gcDom?.parentElement){
                        gcDom.parentElement.style.display = "block";
                    }

                }

                let content = document.getElementById("divcontent");
                if (content) {
                    content.style.display = "block";
                }
                unmountComponentAtNode(document.getElementById("multilocation-portal") as HTMLElement);
            }       

            unmountComponentAtNode(document.getElementById("OpenDialogMultiLocation") as HTMLElement);


        }
    };

    const PopupTitle = () => {
        return (
            <Fragment>
                <span>Select Business Location</span>
                {!utils.IsFromProApp() && <div id="warning-toast-root"></div>}
            </Fragment>
        )

    }

    if (useModal) {

        return createPortal(
            <Fragment>
                {isLoading && <Loader />}
                <VGPopUp
                    show={true}
                    title={PopupTitle()}
                    onHide={handlepopupClose}
                    body={PopupBody()}
                    footer={""}
                    dialogClassName={"modal-fullscreen vgn-modal-alert locationpopup mobile-fullscreen multilocationselectpopup modal-lg modal-dialog-centered modal-dialog-scrollable "}
                    isShowFooter={false}
                    isRemoveTabModalIndex={true}
                    isvgnpopup={true}
                    size="lg"
                />
            </Fragment>,
            document.getElementById("OpenDialogMultiLocation") as HTMLElement
        )


    }


    let dom = document.getElementById("multilocation-portal");
    let contentDom = document.getElementById("divcontent");
    if (!dom) {
        dom = document.createElement("div");
        dom.id = "multilocation-portal";

        if (contentDom) {
            contentDom.before(dom);
        }

    }

    if(isGC){
        let gcDom = document.getElementById("vgGiftCertificte");
        let bg = document.querySelector(".fade.modal-backdrop.show");
        if(bg){
            bg.classList.remove("show");
            (bg as HTMLElement).style.display = "none";
        }

        if(gcDom?.parentElement){
            gcDom.parentElement.style.display = "none";
        }
    }

    if (contentDom) {
        contentDom.style.display = "none";
    }


    return createPortal(
        <Fragment> {isLoading && <Loader />}
            <PopupBody />
        </Fragment>,

        dom
    )
}

export default MultiLocationDropdown;
